import React from 'react';

import { Selection } from '@swf/sports/components';

import type { MarketDynamicBanner } from '../../../../model/types';
import EventStatus from '../components/EventStatus';

import styles from './Standard.scss';

const StandarMarketDynamicBanner: React.FC<MarketDynamicBanner> = ({
  event,
  market,
  eventType,
  competition
}) => (
  <>
    <EventStatus
      marketName={market.marketName}
      eventTypeId={eventType.eventTypeId}
      startTime={event.eventStartTime}
      isTurnInPlay={market.turnInPlayEnabled}
      isInPlay={market.inPlay}
    />
    <div className={styles.runnersContainer}>
      {market.runners.map((runner, i) => (
        <div
          className={styles.runnerContainer}
          key={`${market.marketId}-${runner.runnerName}-${i}`}
        >
          <span className={styles.runnerName}>{runner.runnerName}</span>
          <Selection
            competitionId={competition.competitionId}
            eventId={event.eventId}
            eventTypeId={eventType.eventTypeId}
            handicap={runner.handicap}
            key={runner.selectionId}
            legTypes={market.legTypes}
            marketId={market.marketId}
            marketStatus={market.marketStatus}
            odds={runner.winRunnerOdds}
            runnerResultType={runner.resultType}
            runnerStatus={runner.runnerStatus}
            selectionId={runner.selectionId}
            startTime={event.eventStartTime}
          />
        </div>
      ))}
    </div>
  </>
);

export default StandarMarketDynamicBanner;
